import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useLocale } from './LocaleContext';

const LocaleLink = ({ to, ...props }) => {
  const { loc } = useLocale();
  let resolved = to;
  if (typeof to === 'string') {
    resolved = loc(to);
  } else if (to && typeof to === 'object' && typeof to.pathname === 'string') {
    resolved = { ...to, pathname: loc(to.pathname) };
  }
  return <RouterLink to={resolved} {...props} />;
};

export default LocaleLink;
export { LocaleLink as Link };
